<template>
  <!-- viewBox="0 0 72 72" -->
  <circle cx="36" cy="36" r="36" fill="#F1F4F7" />
  <path
    d="M33.3506 21C40.1717 21 45.7011 26.5308 45.7012 33.3535C45.7012 36.1267 44.7876 38.6864 43.2451 40.748L50.4824 47.9873C51.1714 48.6765 51.1714 49.7942 50.4824 50.4834C49.7935 51.1724 48.6763 51.1723 47.9873 50.4834L40.75 43.2441C38.6876 44.7903 36.1264 45.707 33.3506 45.707C26.5295 45.7069 21 40.1762 21 33.3535C21.0001 26.5309 26.5296 21.0001 33.3506 21ZM33.3506 24.5293C28.4785 24.5294 24.5284 28.4803 24.5283 33.3535C24.5283 38.2268 28.4784 42.1776 33.3506 42.1777C38.2228 42.1777 42.1729 38.2269 42.1729 33.3535C42.1728 28.4802 38.2228 24.5293 33.3506 24.5293Z"
    fill="#8497C2"
  />
  <rect
    x="-0.681024"
    y="0.1796"
    width="6.98161"
    height="12.2494"
    rx="1.5"
    transform="matrix(-0.5 0.866025 -0.862049 -0.506826 29.5454 58.5753)"
    stroke="#DAE5F5"
    fill="none"
  />
  <rect
    x="-0.354561"
    y="0.608553"
    width="5.03418"
    height="9.0167"
    rx="1.5"
    transform="matrix(0.258819 0.965926 -0.96794 0.25118 62.0216 21.7982)"
    stroke="#DAE5F5"
    fill="none"
  />
  <rect
    x="0.499993"
    y="-0.497376"
    width="5.50494"
    height="9.91922"
    rx="1.5"
    transform="matrix(-4.37114e-08 -1 0.999986 0.00524809 9.75127 24.0052)"
    fill="none"
    stroke="white"
  />
</template>
